<template>
    <!-- popup开始 -->
    <div>
        <section class="popup Pop" v-if="errorObj.type=='pop'">
            <div class="box">
                <p class="cell">
                    <span class="con">
                        <!--<span class="title">温馨提示</span>-->
                        <span class="info">{{errorObj.errorMsg}}</span>
                        <!--<a href="javascript:void(0);"
                                               class="btn determine"
                                               ontouchstart="">确定</a>-->
                        <!--<a href="javascript:void(0);" class="btn cancel" ontouchstart="">取消</a>
                                            <a href="javascript:void(0);" class="btn ok" ontouchstart="">确定</a>-->
                    </span>
                </p>
            </div>
        </section>
        <section class="popup Confirm" v-if="errorObj.type=='confirm'">
            <div class="box">
                <p class="cell">
                    <span class="con">
                        <span class="title" style="display: block;">
                            <span style="display: none;">温馨提示</span>
                        </span>
                        <span class="info">{{errorObj.errorMsg}}</span>
                        <!--<a href="javascript:void(0);" class="btn determine" ontouchstart="" style="display: none;">知道了</a>-->
                        <a href="javascript:void(0);" class="btn cancel" @click="confirmClick(false)" style="display: block;">取消</a>
                        <a href="javascript:void(0);" class="btn ok" @click="confirmClick(true)" style="display: block;">取消关注</a>
                    </span>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'popup',
    props: ['popObj'],
    data() {
        return {
            errorObj: this.popObj
        }
    },
    methods: {
        confirmClick(isConfirm) {
            this.errorObj.type = '';
            this.$store.commit('overFlowAuto');
            this.$emit('confirm-click', isConfirm);
        }
    },
    created() {
        if (this.errorObj.type === 'pop') {
            setTimeout(() => {
                this.$store.commit('overFlowAuto');
                this.errorObj.type = '';
            }, 1000);
        }
    }
}
</script>

<style>
/* common pop */

.popup {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
}

.popup.Confirm {
    background-color: rgba(0, 0, 0, .4);
}

.popup .box {
    display: table;
    width: 100%;
    height: 100%;
    text-align: center;
}

.popup .box .cell {
    display: table-cell;
    vertical-align: middle;
}

.popup .box .cell .con {
    margin: 0 .8rem;
    overflow: hidden;
    border-radius: .25rem;
}

.popup.Confirm .box .cell .con {
    margin: 0 1.25rem;
}

.popup.Pop .box .cell .con {
    display: inline-block;
    line-height: 1.2rem;
    background-color: rgba(0, 0, 0, .7);
    font-size: .7rem;
    color: white;
}

.popup.Alert .box .cell .con {
    display: block;
    background-color: white;
}

.popup.Confirm .box .cell .con {
    display: block;
    background-color: white;
}

.popup .box .cell .con .title {
    display: block;
    color: #58595b;
    margin-bottom: .5rem;
    padding-top: 1rem;
    line-height: 0;
    font-size: 0;
}

.popup .box .cell .con .title span {
    font-size: .75rem;
    line-height: .85rem;
}

.popup .box .cell .con .info {
    text-align: center;
}

.popup .box .cell .con .info.left {
    text-align: left;
}

.popup .box .cell .con .info.right {
    text-align: right;
}

.popup.Pop .box .cell .con .info {
    padding: 1rem 1.25rem;
    display: block;
    word-break: break-all;
}

.popup.Alert .box .cell .con .info {
    display: block;
    font-size: .75rem;
    color: #9a9a98;
    line-height: 1.1rem;
    margin-bottom: .5rem;
    margin-top: 0;
    padding: 0 1.25rem;
}

.popup.Alert .box .cell .con .info.frame {
    margin: .75rem 0 1.75rem 0;
}

.popup.Confirm .box .cell .con .info {
    display: block;
    font-size: .75rem;
    color: #9a9a98;
    line-height: 1.1rem;
    margin: .75rem 0 1.75rem 0;
    padding: 0 1.25rem;
}

.popup.Confirm .box .cell .con .info.frame {
    margin-bottom: .5rem;
    margin-top: 0;
}

.popup .box .cell .con .btn {
    background-color: transparent;
    display: block;
    line-height: 1.5rem;
    border-top: 1px solid #dcdcdc;
    color: #58595b;
    font-size: .8rem;
    padding: .375rem 0;
    float: left;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
}

.popup .box .cell .con .btn:active,
.popup .box .cell .con .btn:hover,
.popup .box .cell .con .btn:focus {
    background-color: #f2f2f2;
}

.popup .box .cell .con .btn.determine {
    width: 100%;
}

.popup .box .cell .con .btn.ok {
    width: 50%;
    border-left: 1px solid #dcdcdc;
}

.popup .box .cell .con .btn.cancel {
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// popup.vue?3f6932a4